<template>
  <div class="dialog-wrapper">
    <el-dialog
        :visible.sync="addSquad"
        width="980px"
        :close-on-click-modal="false"
        :before-close="handleBeforeClose"
    >
      <div class="dialog-title" slot="title">教练员帐号开通(开通一名教练员帐号需支付200元/年)</div>
      <div class="dialog-content-wrapper">
        <div class="select-wrapper">
          <div class="select_box">
            <select v-model="selectVal.organUuid" class="yioks_select" @change="changeSelectOrg" >
              <option v-if="selectOrganList.length > 1" value=''>全部区体育行政部门</option>
              <option
                  v-for="item in selectOrganList"
                  :key="item.organUuid"
                  :value="item.organUuid"
              >{{ item.organShortName }}</option>
            </select>
            <select v-model="selectVal.youthUuid" class="yioks_select" @change="changeQuery(true)" >
              <option v-if="selectCenterList.length !== 1" value=''>全部培训机构</option>
              <option
                  v-for="item in selectCenterList"
                  :key="item.uuid"
                  :value="item.uuid"
              >{{ item.youthShortName }}</option>
            </select>

            <select
                v-model="selectVal.coachLimit"
                class="yioks_select"
                @change="changeQuery(true)"
            >
              <option value="0">全部教练</option>
              <option value="1">未到期的教练</option>
              <option value="2">已到期的教练</option>
            </select>
          </div>
          <div class="search_box">
            <input
                v-model.trim="selectVal.keyWord"
                type="text"
                class="yioks_input"
                placeholder="请输入关键词"
                @keyup.enter="changeQuery(true)"
            >
            <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
          </div>
        </div>
        <div class="table-wrapper">
          <div class="table">
            <div class="thead">
              <div class="tr">
                <div class="th check">
                  <strong>
                    全选
                    <el-checkbox v-model="checkedAll"></el-checkbox>
                  </strong>
                </div>
                <div class="th seq">
                  <strong>序号</strong>
                </div>
                <div class="th idName">
                  <strong>姓名</strong>
                </div>
                <div class="th idNumber">
                  <strong>身份证号</strong>
                </div>
                <div class="th coachLimit">
                  <strong>教练状态</strong>
                </div>
                <div class="th coachLimitDate">
                  <strong>到期日期</strong>
                </div>
              </div>
            </div>
            <div class="h430" v-if="pageList.length && !isLoading">
              <vue-scroll :ops="ops">
                <div class="tbody">
                  <div
                      class="tr"
                      v-for="(item, index) in pageList"
                      :key="index"
                  >
                    <div class="td check">
                      <el-checkbox v-model="item.checked"></el-checkbox>
                    </div>
                    <div class="td seq">{{ index + 1 }}</div>
                    <div class="td idName">{{ item.idName }}</div>
                    <div class="td idNumber">{{ item.idNumber | filterIdNumberPrivacy }}</div>
                    <template v-if="item.coachLimitDate < new Date().setHours(0,0,0,0)">
                      <div class="td coachLimit" style="color: #f88594">已到期</div>
                    </template>
                    <template v-else>
                      <div class="td coachLimit">未到期</div>
                    </template>
                    <div class="td coachLimitDate">
                      <p>{{ item.coachLimitDate | time }}</p>
                    </div>
<!--                    <div class="td">-->
<!--                      <p>-->
<!--                        <span-->
<!--                            v-if="!item.checked"-->
<!--                            class="btn suc"-->
<!--                            @click="togglePerformanceStatus(item)"-->
<!--                        >续费</span-->
<!--                        >-->
<!--                        <span-->
<!--                            v-else-->
<!--                            class="btn suc"-->
<!--                            @click="togglePerformanceStatus(item)"-->
<!--                        >取消续费</span-->
<!--                        >-->
<!--                      </p>-->
<!--                    </div>-->
                  </div>
                </div>
              </vue-scroll>
            </div>
            <yioks-empty
                v-if="!isLoading && !pageList.length"
                :whiteBg="true"
                :h="'430px'"
                tips="暂时没有数据"
            ></yioks-empty>
            <div class="bottom-line"></div>
          </div>
        </div>

        <yioks-loading v-if="isLoading" />
      </div>
      <div slot="footer" class="footer-btns-big">
        <el-button type="primary" :loading="addbtnLoading" @click="handleDialogAction('confirm')"
        >续 费</el-button
        >
        <el-button type="danger" @click="handleDialogAction('cancel')"
        >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ops } from "@/utils/scrollIndialog";
import coach from "@/api/coach";
import pay from '@/api/pay'
import storage from '@/utils/storage'

export default {
  props: {
    addSquad: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  data() {
    return {
      ops,
      pageList: [],
      isLoading: false,
      addbtnLoading: false,
      userRole: storage.get('userInfo').userRole,
      uuid: storage.get('userInfo').uuid,
      selectVal: {
        keyWord: "",
        youthUuid: "",
        youthShortName: "",
        organUuid: "",
        organShortName: "",
        className: "", // 培训班
        classLevel: "", // 教练员等级
        coachLimit: 2, // 教练员是否到期
      },
      selectOrganList: [],
      selectCenterList: [],
    };
  },
  computed: {
    checkedAll: {
      get() {
        let res = true;
        if (this.pageList.length) {
          const list = JSON.parse(JSON.stringify(this.pageList));
          list.forEach((item) => {
            if (!item.checked) {
              res = false;
            }
          });
          return res;
        } else {
          return false;
        }
      },
      set(val) {
        this.pageList.forEach((item) => {
          item.checked = val;
        });
      },
    },
  },

  created() {
    this.getOrganListAndCenterList();
    this.loadPageList();
  },

  methods: {
    handleBeforeClose() {
      this.setDialogStatus(false);
    },

    setDialogStatus(flag) {
      this.$emit("update:addSquad", flag);
    },

    handleDialogAction(flag) {
      this.addbtnLoading = true;
      if (flag == "confirm") {
        // 获取选中的教练信息
        let coachListShow = this.pageList.filter((item) => {
          return item.checked;
        });
        // 构造选中的教练信息
        coachListShow = coachListShow.map((item) => {
          const { idName, uuid } = item;
          return {
            coachUuid: uuid,
            idName: idName,
          };
        });

        let requestData = {
          payToCoach: {
            payToCoachNum:coachListShow.length,
            renewToCoachLimit:1,
            organUuid:this.selectVal.organUuid,
            organShortName:this.selectVal.organShortName,
            youthUuid:this.selectVal.youthUuid,
            youthShortName:this.selectVal.youthShortName,
            payToCoachType:'renew',
          },
          payToCoachRenewList:coachListShow
        };

        if(coachListShow.length)  {
          pay.renewAdd(requestData).then(res => {
            this.addbtnLoading = false;
            // 重复处理
            if (res.code) {
              this.$message.error(res.msg)
            } else {
              this.$router.push({
                path:'renewDetail',
                query:{uuid:res}
              })
            }
          }).catch(err => {
            this.addbtnLoading = false;
            console.error(err)
          })
        } else {
          this.$message.error("请选择需要开通的教练帐号");
          this.addbtnLoading = false;
        }

      } else if (flag == "cancel") {
        this.$emit("hideAddRenewDialog", false, true);
        this.addbtnLoading = false;
      }
    },

    togglePerformanceStatus(row) {
      row.checked = !row.checked;
    },

    // 查询列表信息
    loadPageList() {
      this.isLoading = true;
      let req = coach.getCoachBySystem;
      if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        req = coach.getCoachByYouth;
      }

      req({
        key: this.selectVal.keyWord,
        organUuid: this.selectVal.organUuid,
        youthUuid: this.selectVal.youthUuid,
        coachLimit: this.selectVal.coachLimit,
      })
        .then((res) => {
          this.isLoading = false;
          this.pageList = res.map((item) => {
            return {
              ...item,
              checked: false,
            };
          });
        })
        .catch((err) => {
          this.isLoading = false;
          console.error(err);
        });
    },

    getOrganListAndCenterList () {
      let data = this.uuid;
      let request;
      if (this.userRole === 'organ') {
        request = coach.getCenterListByOrgan
      } else if (this.userRole === 'system' || this.userRole === 'admin') {
        request = coach.getCenterListBySystem;
        data = ''
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = coach.getCenterListByYouth
      }
      request(data).then((res) => {
        this.organList = res;
        this.selectOrganList = res;
        if (this.organList.length === 1) {
          this.$set(this.selectVal, 'organUuid', this.organList[0].organUuid);
          this.$set(this.selectVal, 'organShortName', this.organList[0].organShortName);
          this.selectCenterList = this.selectOrganList.find(item => {
            return item.organUuid === this.selectVal.organUuid
          }).youthList || [];
          if (this.selectCenterList.length === 1) {
            this.$set(this.selectVal, 'youthUuid', this.selectCenterList[0].uuid)
            this.$set(this.selectVal, 'youthShortName', this.selectCenterList[0].youthShortName)
          }
        }
        this.selectVal.organUuid && this.setCenterList()
      });
    },
    setCenterList () {
      this.selectCenterList = this.selectOrganList.find(item => {
        return item.organUuid === this.selectVal.organUuid
      }).youthList || [];
      this.centerList = this.selectCenterList
    },
    changeSelectOrg () {
      this.$set(this.selectVal, 'youthUuid', '');
      this.$set(this.selectVal, 'youthShortName', '');
      if (this.selectVal.organUuid) {
        this.selectCenterList = this.selectOrganList.find(item => {
          return item.organUuid === this.selectVal.organUuid
        }).youthList || [];
        if (this.selectCenterList.length === 1) {
          this.$set(this.selectVal, 'youthUuid', this.selectCenterList[0].uuid)
          this.$set(this.selectVal, 'youthShortName', this.selectCenterList[0].youthShortName)
        }
      } else {
        this.selectCenterList = [];
        this.$set(this.selectVal, 'youthUuid', '')
        this.$set(this.selectVal, 'youthShortName', '')
      }
      this.changeQuery(true)
    },

    changeQuery (flag) {
      if (flag) this.page = 0;
      this.$router.replace({
        query: {
          key: this.selectVal.keyWord,
          youthUuid: this.selectVal.youthUuid,
          organUuid: this.selectVal.organUuid,
          coachLimit: this.selectVal.coachLimit,
        }
      })
      this.loadPageList()
    },

  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/yioks_page_table'
@import '~@/assets/css/yioks_table'
.dialog-title
  color #606266
  font-weight 600
  font-size 1.3em
  border-bottom 1px solid #606266
  padding-bottom 5px
.dialog-content-wrapper
  height 500px
  .table-wrapper
    margin-right 20px
.h430
  height 430px
.bottom-line
  margin-right 20px
  border-bottom 1px solid #666
.select-wrapper
  //margin-right 40px
  //margin-bottom 10px
  padding 0 40px 10px 0
  display flex
  justify-content space-between
  .select_box,.search_box
    display flex
    .yioks_select
      height 40px
      outline none
      padding 0 10px
      margin-right 10px
      width: 170px;
      color #666;
      border-style solid;
      &:last-child
        margin-right 10px
    .yioks_input
      padding 10px
      width 160px
      border-style solid;
      border-width 1px
      border-color #666;
    .yioks_btn
      color #FFF
.dialog-wrapper
  /deep/.el-dialog__body
    padding-top 10px
  /deep/.el-button--success
    background-color $green_color !important
    color #fff
.check
  flex none !important
  width 11%
.seq
  flex none !important
  width 10%
.idName
  flex none !important
  width 20%
.idNumber
  flex none !important
  width 25%
.coachLimit
  flex none !important
  width 17%
.coachLimitDate
  flex none !important
  width 17%
  p
    white-space nowrap
    overflow hidden
    text-overflow ellipsis
</style>
